import { RootState } from 'src/redux/createRootReducer'

export const selectLoadingOrgIntegrationsFromState = (
  state: RootState,
): boolean => state.app.orgIntegration.loadingOrgIntegrations

export const selectTopLevelOrgIntegrationsError = (
  state: RootState,
): string | undefined => state.app.orgIntegration.topLevelError

export const selectIntegrationsModalOpen = (state: RootState): boolean =>
  state.app.isCreateOrgIntegrationOpen ||
  state.app.isManageOrgIntegrationPopupOpen
